import React, { forwardRef, useEffect, useId, useImperativeHandle, useRef } from 'react';
import { useDroppable } from '@dnd-kit/react';
import { defaultCollisionDetection } from '@dnd-kit/collision';
import { CollisionPriority } from '@dnd-kit/abstract';
import { DragMetadata, DroppableProps } from './types';
type DropTargetProps = React.HTMLAttributes<HTMLDivElement> & DroppableProps & {
  ref?: React.Ref<HTMLDivElement>;
  children?: React.ReactNode;
};

/**
 * Component that allows dropping draggable entries with a specified entry type handler
 */
export const DropZone = forwardRef<HTMLDivElement, DropTargetProps>(function DropTarget(props, forwardedRef) {
  const ref = useRef<HTMLDivElement>(null);
  const dragId = useId();
  const {
    isDropTarget
  } = useDroppable({
    element: ref.current,
    collisionDetector: defaultCollisionDetection,
    collisionPriority: CollisionPriority.Normal,
    id: "".concat(dragId, "-droppable"),
    data: props.data,
    accept(source) {
      var _fn;
      if (!source.type || typeof source.type !== "string" || !props.accepts) {
        return false;
      }
      const fn = props.accepts[source.type as DragMetadata[`type`]];
      if (!fn) {
        return false;
      }
      return (_fn = fn(source.data as DragMetadata)) !== null && _fn !== void 0 ? _fn : false;
    }
  });
  useEffect(() => {
    var _ref$current;
    (_ref$current = ref.current) === null || _ref$current === void 0 || _ref$current.toggleAttribute("data-dnd-is-drop-target", isDropTarget);
  }, [isDropTarget]);
  useImperativeHandle(forwardedRef, () => ref.current!);
  return <div {...props} ref={ref}>
      {props.children}
    </div>;
});